var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grid grid-cols-1 lg:grid-cols-2 gap-6"},[(_vm.$store.getters['account/account'] && _vm.$store.getters['account/account'].agreements.length)?_c('AccountAgreements',{staticClass:"lg:col-span-1"}):_vm._e(),_c('AccountAddclub',{staticClass:"lg:col-span-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }